import * as fuse_pkg from "fuse.js";

type FuseOptions = {
  keys?: string[];
  threshold?: number;
  ignoreLocation?: boolean;
};

type FuseSearchResult<T> = {
  item: T;
};

type FuseConstructor = new <T>(
  list: ReadonlyArray<T>,
  options?: FuseOptions,
) => {
  search(pattern: string): Array<FuseSearchResult<T>>;
};

const Fuse = fuse_pkg.default as unknown as FuseConstructor;

export const createFuse = <T>(list: ReadonlyArray<T>, options?: FuseOptions) =>
  new Fuse<T>(list, options);

export const searchFuseItems = <T>(
  list: ReadonlyArray<T>,
  pattern: string,
  options?: FuseOptions,
) =>
  createFuse(list, options)
    .search(pattern)
    .map(({ item }) => item);

export const searchFuseRecordItems = (
  list: ReadonlyArray<Record<string, string>>,
  pattern: string,
  optionsKey: string,
) => searchFuseItems(list, pattern, { keys: [optionsKey] });
